import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectEnabledFeatures, selectIsAuth, selectRole, selectModules } from '../store/authSlice';

/**
 * ProtectedRoute — guards by authentication, role, and module access.
 * Props:
 *   roles   (array)  — allowed roles, e.g. ['ADMIN','DOCTOR']
 *   module  (string) — required module, e.g. 'HEALTHCARE'
 */
export default function ProtectedRoute({
  children,
  roles   = [],
  module  = null,
  feature = null,
}) {
  const isAuth  = useSelector(selectIsAuth);
  const role    = useSelector(selectRole);
  const modules = useSelector(selectModules);
  const enabledFeatures = useSelector(selectEnabledFeatures);
  const location = useLocation();

  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles.length > 0 && !roles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (module && !modules.includes(module)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (feature) {
    const hasFeature = (enabledFeatures || []).some(f => f === feature || String(f).startsWith(feature + ':'));
    if (!hasFeature) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
}
